import { cn } from "@/lib/utils"
import { TButton } from "@/components/ui/atoms"
import {
  CardNewsEvent,
  TCardNewsEventProps,
  TPagination,
} from "@/components/ui/molecules"
import { CardListContainer } from "@/components/ui/organisms"

type TCardNewsEventListProps = {
  title?: string
  className?: string
  smallInfo?: string
  list: TCardNewsEventProps[]
  buttons?: TButton[]
  paginationList?: TPagination[]
  backgroundWhite?: boolean
}

const CardNewsEventList = ({
  title,
  list,
  className,
  buttons,
  backgroundWhite = false,
  smallInfo,
  paginationList,
}: TCardNewsEventListProps) => {
  return (
    <div
      className={cn(
        "py-10 lg:py-17",
        className,
        backgroundWhite ? "bg-neutral-100" : "bg-neutral-200"
      )}
    >
      <CardListContainer
        title={title}
        titleCenter={true}
        smallInfo={smallInfo}
        className={className}
        backgroundWhite={backgroundWhite}
        buttons={buttons}
        paginationList={paginationList}
      >
        {list?.map((news) => (
          <CardNewsEvent key={news?.id} {...news} />
        ))}
      </CardListContainer>
    </div>
  )
}

export { CardNewsEventList, type TCardNewsEventListProps }
